import { useDynamicEntityStoreContext } from '../contexts';

import CategorySchemaMapperInput from './_template_mapper/CategorySchemaMapperInput';
import JobSchemaMapperInput from './_template_mapper/JobSchemaMapperInput';

export default function TemplateMapper({ handleChange, value }) {
  const assignedCategory = useDynamicEntityStoreContext((state) => state.data.assigned_category);
  const isAssignedToJobs = useDynamicEntityStoreContext((state) => state.data.is_assigned_to_jobs);

  if (assignedCategory) {
    return <CategorySchemaMapperInput {...{ handleChange, value }} />;
  }

  if (isAssignedToJobs) {
    return <JobSchemaMapperInput {...{ handleChange, value }} />;
  }

  return (
    <div className="d-flex flex-column text-muted h-100">
      <span style={{ fontSize: 32 }}>😓</span>
      <span>No mapping options available. Please assign to a category or jobs to begin mapping.</span>
    </div>
  );
}
